import { tv } from 'tailwind-variants';

export const chip = tv({
  base: 'rounded-[64px] text-center px-3 py-1 flex justify-center items-center gap-2 border border-transparent',
  variants: {
    variant: {
      default: 'bg-color-brand-primary text-mono-color-white border-color-brand-primary',
      easy: 'bg-disciplina-fisica text-mono-color-white border-disciplina-fisica',
      medium: 'bg-disciplina-ingles text-mono-color-white border-disciplina-ingles',
      hard: 'bg-disciplina-quimica text-mono-color-white border-disciplina-quimica',
    },
    type: {
      filled: '',
      outline: 'bg-transparent text-current',
    },
    disabled: {
      true: 'opacity-50 !cursor-not-allowed bg-transparent text-mono-color-medium border-mono-color-medium',
    },
    clickable: {
      true: 'cursor-pointer',
    },
  },
  compoundVariants: [
    { variant: 'easy', type: 'outline', class: 'border-hairline !text-disciplina-fisica bg-transparent border-disciplina-fisica' },
    { variant: 'medium', type: 'outline', class: 'border-hairline !text-disciplina-ingles bg-transparent border-disciplina-ingles' },
    { variant: 'hard', type: 'outline', class: 'border-hairline !text-disciplina-quimica bg-transparent border-disciplina-quimica' },
    { variant: 'default', type: 'outline', class: 'border-hairline !text-color-brand-primary bg-transparent border-color-brand-primary' },
    { type: 'filled', disabled: true, class: 'opacity-50 !cursor-not-allowed !bg-mono-color-light !text-mono-color-medium !border-mono-color-light' },
    { type: 'outline', disabled: true, class: 'opacity-50 !cursor-not-allowed !bg-transparent !text-mono-color-medium !border-mono-color-medium' },
  ],
  defaultVariants: {
    type: 'filled',
  },
});
